import {
  PaletteOptions,
  SimplePaletteColorOptions,
  TypeAction,
  TypeText,
} from '@mui/material'

import {
  action,
  background,
  error,
  primary,
  secondary,
  text,
  warning,
  success,
  primaryLkm,
  secondaryLkm,
} from './colors'
import { isLkmDomain } from 'router/utils'

interface ExtendedPaletteColorOptions extends SimplePaletteColorOptions {
  light?: string
  main: string
  dark?: string
  contrastText?: string
}

interface ExtendedPaletteOptions extends PaletteOptions {
  primary?: ExtendedPaletteColorOptions
  secondary?: ExtendedPaletteColorOptions
  text?: Partial<TypeText>
  error?: ExtendedPaletteColorOptions
  warning?: ExtendedPaletteColorOptions
  info?: ExtendedPaletteColorOptions
  success?: ExtendedPaletteColorOptions
  action?: Partial<TypeAction>
}
const isLkm = isLkmDomain()

export const palette: ExtendedPaletteOptions = {
  primary: {
    main: isLkm ? primaryLkm.main : primary.main,
    dark: isLkm ? primaryLkm.dark : primary.dark,
  },
  secondary: {
    main: isLkm ? secondaryLkm.main : secondary.main,
    dark: isLkm ? secondaryLkm.dark : secondary.dark,
    contrastText: isLkm ? secondaryLkm.contrast : secondary.contrast,
  },
  action: {
    disabled: action.disabled,
    active: action.active,
    disabledBackground: action.disabledBackground,
  },
  text: {
    primary: text.primary,
    secondary: text.secondary,
    disabled: text.disabled,
  },
  background: {
    paper: background.paper,
    default: background.default,
  },
  error: {
    main: error.main,
    dark: error.dark,
    contrastText: error.contrast,
  },
  warning: {
    main: warning.main,
    dark: warning.dark,
    contrastText: warning.contrast,
  },
  success: {
    main: success.main,
    dark: success.dark,
    contrastText: success.contrast,
  },
}
